import { IApplicationState } from '../../types/redux';

export const getIsDistanceCalculatingEnabled = (state: IApplicationState) => {
  const { distanceCalculating } = state;

  return distanceCalculating.isEnabled;
};
